<template>
  <div>
    <div v-if="oprationType == 'edit'" class="project-name">
      <b>{{project.name}}</b>
    </div>
    <div class="info mb-3">
      <div class="header">{{$t("properties")}}</div>
      <div class="bd">
        <div class="projectCol">
          <div class="flex items-center mb-6">
            <label class="labelwidth-100 mr-6 mark">{{ $t("projectName") }}</label>
            <vs-input class='w' v-model="project.name" :placeholder="$t('projectName')" />
          </div>
        </div>
        <div class="projectCol flex justify-between">
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6 mark">{{ $t("startDate") }}</label>
            <flat-pickr
              class="small-input"
              :placeholder="$t('startDate')"
              :config="configFromdateTimePicker"
              @on-change="onFromChange"
              :lable="$t('startDate')"
              v-model="project.startOn"
            />
          </div>
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6 mark">{{ $t("endDate") }}</label>
            <flat-pickr
              class="small-input"
              :config="configTodateTimePicker"
              @on-change="onToChange"
              :placeholder="$t('endDate')"
              :lable="$t('endDate')"
              v-model="project.endOn"
            />
          </div>
        </div>

        <div class="projectCol flex justify-between">
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6 ">{{ $t("OperationstartDate") }}</label>
            <flat-pickr
              class="small-input"
              :placeholder="$t('OperationstartDate')"
              :lable="$t('OperationstartDate')"
              v-model="project.maintainStartOn"
            />
          </div>
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6 ">{{ $t("OperationEndDate") }}</label>
            <flat-pickr
              class="small-input"
              :placeholder="$t('OperationEndDate')"
              :lable="$t('OperationEndDate')"
              v-model="project.maintainEndOn"
            />
          </div>
        </div>

        <div class="projectCol flex justify-between">
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6">{{ $t("type") }}</label>
            <v-select
              class="no-clear small"
              :placeholder="$t('type')"
              :options="typeList"
              label="name"
              v-model="project.type"
            ></v-select>
          </div>
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6">{{ $t("status") }}</label>
            <v-select
              class="no-clear small"
              :placeholder="$t('status')"
              :options="statusList"
              v-model="project.status"
            ></v-select>
          </div>
        </div>
        <div>
          <label class="labelwidth-100">{{ $t("desc") }}</label>
          <vue-editor
            class="mt-2 mb-6"
            :placeholder="$t('desc')"
            useCustomImageHandler
            @imageAdded="handleImageAdded"
            v-model="project.description"
          ></vue-editor>
          <!-- <vs-textarea
            :rows="3"
            v-model="project.description"
            :placeholder="$t('desc')"
          ></vs-textarea> -->
        </div>
        <div class="place flex justify-between items-center mb-3">
          <label class="labelwidth-100 mr-3 mark">{{ $t("placeInfo") }}</label>
          <v-select
            class="no-clear small mr-3"
            :placeholder="$t('province')"
            :options="placeInfo.province"
            label="name"
            v-model="address.province"
          ></v-select>
          <v-select
            class="no-clear small mr-3"
            :placeholder="$t('city')"
            :options="placeInfo.city"
            label="name"
            v-model="address.city"
          ></v-select>
          <v-select
            class="no-clear small mr-3"
            :placeholder="$t('district')"
            :options="placeInfo.area"
            label="name"
            v-model="address.area"
          ></v-select>
          <vs-input class='' v-model="project.detailedAddress" :placeholder="$t('detailAddress')" />
        </div>
      </div>
    </div>
    
    <div class="info mb-3">
      <div class="header">{{$t("projectContract")}}</div>
      <div class="bd">
        <div class="projectCol flex justify-between">
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6 mark">{{ $t("customer") }}</label>
            <v-select
              class="no-clear small mr-3"
              :placeholder="$t('customer')"
              :options="consumerList"
              label="name"
              value="name"
              v-model="consumerSelect"
            ></v-select>
            <!-- <v-select
              class="owner-Select no-clear mr-3"
              :placeholder="$t('customer')"
              :options="consumerList"
              label="name"
              value="name"
              v-model="consumerSelect"
            ></v-select> -->
          </div>
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6">{{ $t("contractAmount") }}</label>
            <vs-input
              class
              v-model="contractList.contractPrice"
              :placeholder="$t('contractAmount')"
            />
          </div>
        </div>
        <div class="projectCol flex justify-between">
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6">{{ $t("contractName") }}</label>
            <vs-input
              class
              v-model="contractList.contractName"
              :placeholder="$t('contractName')"
            />
          </div>
          <div class="flex justify-between items-center mb-6">
            <label class="labelwidth-100 mr-6">{{ $t("contractCode") }}</label>
            <vs-input
              class
              v-model="contractList.contractNumber"
              :placeholder="$t('contractCode')"
            />
          </div>
        </div>
        <div class="flex items-center">
          <label class="labelwidth-100 mr-5">{{ $t("attachment") }}</label>
          <span
            @click="openUploader('fileUploader')"
            class="flex items-center cursor-pointer text-primary"
          >
            <feather-icon
              class="mr-2"
              icon="UploadCloudIcon"
              svg-classes="w-4 h-4"
            />
            <span class="font-12">{{ $t("upload") }}</span>
          </span>
        </div>
        <div class="flex flex-wrap" v-if="project.files">
          <div
            class="thumbnil relative"
            :key="index"
            v-for="(file, index) of project.files"
          >
            <div v-if="file.type=='contract'">
              <div v-if="file.contentType.includes('image')">
              <img
                height="80"
                :src="'/file/v1/cdn/public/' + file.id"
                :title="file.alias"
                :alt="file.alias"
              />
              </div>
              <div v-else>
                <img
                  height="80"
                  src="@/assets/images/icons/fileIcon.svg"
                  :title="file.alias"
                  :alt="file.alias"
                />
              </div>
              <div class="flex items-center text-center thumbnil_detail">
                <feather-icon
                  @click="removeDocument(file, index)"
                  class="cursor-pointer remove-file"
                  icon="XIcon"
                  svg-classes="w-4 h-4"
                />
                <!-- <a
                  name="file"
                  :download="file.fileName"
                  :href="'/cdn/getFileByName?name=' + file.fileName"
                  target="_blank"
                >
                  <p>{{ file.alias }}</p>
                </a> -->
                <a href="javascript:void(0)" @click="updateFile(file)">
                  <p>{{ file.alias }}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info mb-3">
      <div class="header">{{$t("projectMember")}}</div>
      <div class="bd">
        <div >
          <div class="flex items-center mb-6">
           <div class="flex projectCols items-center mr-16">
              <label class="labelwidth-100 mr-6 mark">{{ $t("projectManager") }}</label>
              <v-select
                class="no-clear small"
                :placeholder="$t('projectManager')"
                :options="userList"
                label="displayName"
                value="accountNo"
                v-model="selectProjectManager"
              ></v-select>
            </div>
            <div class="flex items-center">
              <label class="labelwidth-100 mr-6">{{ $t("customerManager") }}</label>
              <vs-input
                class="mr-6"
                :name="$t('customerManager')"
                v-validate="'max:10'"
                v-model="projectList.projectManagerName"
                :placeholder="$t('realname')"
              />
              <vs-input
                :name="$t('customerManager')+ $t('mobile')"
                type="number"
                v-validate="'phone'"
                v-model="projectList.projectContactMobile"
                :placeholder="$t('contactMobile')"
              />
            </div>
          </div>
          <div class="flex items-center mb-6">
           <div class="flex projectCols items-center mr-16">
              <label class="labelwidth-100 mr-6">{{ $t("projectMembers") }}</label>
              <v-select
                class="no-clear small"
                :placeholder="$t('projectMembers')"
                :options="userList"
                label="displayName"
                value="accountNo"
                v-model="selectProjectMember"
              ></v-select>
              <feather-icon
                @click="addMember(selectProjectMember, 'project')"
                class="cursor-pointer ml-2"
                icon="PlusIcon"
                svg-classes="w-4 h-4"
              />
           </div>
           <div class="flex items-center ">
              <label class="labelwidth-100 mr-6">{{ $t("ProjectStakeholders") }}</label>
              <vs-input
                class="mr-6 "
                :name="$t('ProjectStakeholders')"
                v-validate="'max:10'"
                v-model="projectList.stakeholdersName"
                :placeholder="$t('realname')"
              />
              <vs-input
                class
                type="number"
                v-validate="'phone'"
                :name="$t('ProjectStakeholders') + $t('mobile')"
                v-model="projectList.stakeholdersMobile"
                :placeholder="$t('contactMobile')"
              />
               <feather-icon
                @click="addProjectStakeholders(projectList)"
                class="cursor-pointer ml-2"
                icon="PlusIcon"
                svg-classes="w-4 h-4"
              />
           </div>
          </div>
          <div class="flex mb-6">
            <div class="flex items-center mr-16 w-400" >
              <div class="projectMember w-300 mt-3" v-if="projectMemberList&&projectMemberList.length">
                <div :key='index' class="flex justify-between mb-3" v-for="(item, index) in projectMemberList">
                  <div class="userSelect mr-3">
                    <label class="vs-input--label font-13">{{item.displayName}}</label>
                  </div>
                  <div>
                    <feather-icon @click="memberDel(index,item.id, 'project')" class='cursor-pointer' icon='Trash2Icon'
                        svg-classes="w-4 h-4" />
                  </div>
                </div>
              </div>
              <div v-else class=" items-left">No data Available</div>
            </div>
            <div class=" f-1 items-center mr-20">
              <div class="mt-3" v-if="stakeholdersList&&stakeholdersList.length">
                <div :key='index' class="flex justify-between mb-3" v-for="(item, index) in stakeholdersList">
                  <div class="mr-3">
                    <label class="pt-6 vs-input--label font-13 font-weight-normal">{{$t('realname')}} :</label>
                    <label class="pt-6 vs-input--label font-13 mr-10">{{item.name}}</label>
                    <label class="pt-6 vs-input--label font-13 font-weight-normal">{{$t('contactMobile')}} : </label>
                    <label class="pt-6 vs-input--label font-13">{{item.phoneNumber}}</label>
                  </div>
                  <div>
                    <feather-icon @click="memberDel(index,item.name, 'stakeholders')" class='cursor-pointer' icon='Trash2Icon'
                        svg-classes="w-4 h-4" />
                  </div>
                </div>
              </div>
              <div v-else class=" items-left">No data Available</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <vs-button
        v-if="oprationType == 'add'"
        type="border"
        @click="createProject()"
        >{{ $t("create") }}</vs-button>
      <vs-button
        v-if="oprationType == 'edit'"
        type="border"
        @click="editProject()"
        >{{ $t("save") }}</vs-button>
      <!-- <vs-divider class="my-5" border-style="dashed" color="primary">{{$t('business')}}</vs-divider> -->
    </div>
    <input
      v-show="false"
      @change="uploadAttachment($event)"
      ref="fileInput"
      type="file"
      id="fileUploader"
    />
  </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import pmapi from "@/api/pmapi.js";
import cdnapi from "@/api/cdnapi.js";
import openapi from "@/api/openapi.js";
import { VueEditor } from "vue2-editor";
import { commonUpdateFile } from '@/components/common/common.js';

export default {
  name: "ProjectComponent",
  props: {
    oprationType: {
      type: String,
      default: "add",
    },
    data: {
      default: {
        bizCode: "",
        createdBy: "",
        createdOn: "",
        id: "",
        name: "",
        type: "",
        status: "",
        projectManager: null,
        startOn: "",
        endOn: "",
        description: "",
        files: [],
        province: '',
        city: '',
        area: '',
        detailedAddress: '',
        contractList: [],
        projectMembers: []
      },
    },
  },
  components: { flatPickr, VueEditor },
  data() {
    return {
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null,
      },
      configTodateTimePicker: {
        minDate: null,
      },
      project: {
        name: "",
        type: "",
        status: "ACTIVE",
        projectManager: "",
        startOn: "",
        endOn: "",
        maintainStartOn:'',
        maintainEndOn: '',
        description: "",
        files: [],
        province: '',
        city: '',
        area: '',
        detailedAddress: '',
        contractList: [],
        projectMembers: []
      },
      selectProjectManager: "",
      selectProjectMember: "",
      // typeList: [this.$t("governmentProject"), this.$t("itProject")],
      typeList: [],
      statusList: ["ACTIVE", "DELETED"],
      placeInfo: { // 位置信息数据
        province: [],
        city: [],
        area: []
      },
      address: { // 选择的位置
        province: '',
        city: '',
        area: '',
      },
      consumerList: [],
      consumerSelect: '',
      contractList: {
        contractCompany: '',
        contractPrice: '',
        contractNumber: '',
        contractName: ''
      },
      projectMemberList: [],
      stakeholdersList:[],
      projectList:{
        projectManagerName:'',
        projectContactMobile:'',
        stakeholdersName:'',
        stakeholdersMobile:'',
      }
    };
  },
  watch: {
    data() {
      if (this.oprationType == "edit") {
        this.project = { ...this.data };
        this.selectProjectManager = this.project.projectManager;
        this.projectMemberList = this.project.projectMembers;
        this.contractList = this.project.contractList[0];
        this.consumerSelect = {id:this.contractList.contractCompany,name:this.contractList.contractCompanyName};
        this.address.province = this.project.province;
        this.address.city = this.project.city;
        this.address.area = this.project.area;
        this.address.type = 1
        this.projectList.projectManagerName = this.project.personManager ? this.project.personManager.name : '';
        this.projectList.projectContactMobile = this.project.personManager ? this.project.personManager.phoneNumber : '';
        this.stakeholdersList = this.project.personMembers ? this.project.personMembers : []
      }
    },
    consumerSelect(val) {
      this.contractList.contractCompany = val.id
    },
    "address.province": {
      handler(val) {
        this.getAddress('city',val.id);
        this.project.province = val?val.id:''
        if(this.address.type !==1 ) {
          this.address.city = ''
          this.address.area = ''
        }
      }
    },
    "address.city": {
      handler(val) {
        this.getAddress('area',val.id);
        this.project.city = val?val.id:''
        if(this.address.type !==1 ) {
          this.address.area = ''
        }
      }
    },
    "address.area": {
      handler(val) {
        this.project.area = val?val.id:''
      }
    }
  },
  computed: {
    userList() {
      return this.$store.state.myUsers;
    },
    isFormValid() {
      return this.project.name && this.project.startOn && this.project.endOn && this.project.province && this.project.city 
      && this.project.area && this.project.detailedAddress && this.project.contractList[0].contractCompany && this.project.projectManager
    }
  },
  mounted() {
    if (this.oprationType == "edit" && this.data.id) {
      this.project = { ...this.data };
      this.selectProjectManager = this.project.projectManager;
      this.projectMemberList = this.project.projectMembers;
      this.contractList = this.project.contractList[0];
      this.consumerSelect = {id:this.contractList.contractCompany,name:this.contractList.contractCompanyName};
      this.address.province = this.project.province;
      this.address.city = this.project.city;
      this.address.area = this.project.area;
      this.address.type = 1
      this.projectList.projectManagerName = this.project.personManager ? this.project.personManager.name : '';
      this.projectList.projectContactMobile = this.project.personManager ? this.project.personManager.phoneNumber : '';
      this.stakeholdersList = this.project.personMembers ? this.project.personMembers : []
    }
    this.getTypeList()
  },
  methods: {
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    openUploader(id) {
      this.$refs.fileInput.click();
    },
    uploadAttachment(event) {
      let file = event.target.files[0];
      var formData = new FormData();
      formData.append("file", file);
      if(!this.project.id) {
        this.project.id = ''
      }
      this.$tools
        .ajax(`${cdnapi.publicFile}?type=project&typeId=${this.project.id}&typeName=${this.project.name}&folder=contract`, "put", formData, 1)
        .then((result) => {
          result.type = 'contract';
          result.typeId = this.project.id
          if(this.oprationType == "edit"){
            this.$tools
              .ajax(
                `${pmapi.projects}/${this.project.id}/document`,
                "patch",
                result,
                1
              )
              .then(() => {
                this.project.files.push(result);
              });
          }else{
            this.project.files.push(result);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUser(accountNo) {
      let user = this.userList.filter((user) => user.accountNo == accountNo);
      if (user[0]) {
        return user[0];
      } else {
        return "";
      }
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("file", file);
      this.$tools
        .ajax(`${cdnapi.publicFile}?type=project&typeId=${this.project.id}&typeName=${this.project.name}&folder=''`, "put", formData, 1)
        .then((result) => {
          let url = `/file/v1/cdn/public/` + result.id;
          this.data.images.push(result);
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createProject() {
      let projectManager = this.selectProjectManager;
      if (Object.keys(projectManager).includes("accountNo")) {
        projectManager = projectManager.accountNo;
      }

      let projectMembers = [];
      this.projectMemberList.forEach(item => {
        projectMembers.push(item.accountNo)
      });

      let contractList = []
      contractList.push(this.contractList)

      this.project = {
        ...this.project,
        projectManager: projectManager,
        projectMembers: projectMembers,
        contractList: contractList,
        personMembers:this.stakeholdersList,
        personManager:{
          name: this.projectList.projectManagerName,
          phoneNumber: this.projectList.projectContactMobile  
        }
      };

      let files = this.$tools.deepCopy(this.project.files)
      this.project.files = []; // 创建项目时不保存上传的文件，后面会更新文件，避免重复

      if (!this.isFormValid) {
        this.$vs.notify({
          position: "top-center",
          time: 3000,
          color: "warning",
          text: this.$t("fillTips"),
        });
        return;
      }
      if ((this.project.maintainStartOn && this.project.maintainEndOn) || (this.project.maintainStartOn == '' && this.project.maintainEndOn == '')) {
      } else {
        this.$vs.notify({
          position: "top-center",
          time: 3000,
          color: "warning",
          text: this.$t("OperationstartDate") + ', '+this.$t("OperationEndDate")+ this.$t("textNull"),
        });
        return;
      }
      this.project.files = files
      this.$tools.ajax(pmapi.projects, "post", this.project, 1).then((data) => {
        // files.forEach(item => {
        //   item.typeId = data.id
        //   setTimeout(this.updateProjectData(item),300)
        // })
        this.$router.go(-1);
      });
    },
    editProject() {
      if(this.inputValidate())return; // 验证信息输入是否正确
      let projectManager = this.selectProjectManager;
      if (projectManager && projectManager.hasOwnProperty("accountNo")) {
        projectManager = projectManager.accountNo;
      }

      let projectMembers = [];
      this.projectMemberList.forEach(item => {
        projectMembers.push(item.accountNo)
      });

      let contractList = []
      contractList.push(this.contractList)

      this.project = {
        ...this.project,
        projectManager: projectManager,
        projectMembers: projectMembers,
        contractList: contractList,
        personMembers:this.stakeholdersList,
        personManager:{
          name: this.projectList.projectManagerName,
          phoneNumber: this.projectList.projectContactMobile  
        }
      };

      if (!this.isFormValid) {
        this.$vs.notify({
          position: "top-center",
          time: 3000,
          color: "warning",
          text: this.$t("fillTips"),
        });
        return;
      }
      if ((this.project.maintainStartOn && this.project.maintainEndOn) || (this.project.maintainStartOn == '' && this.project.maintainEndOn == '')) {
      } else {
        this.$vs.notify({
          position: "top-center",
          time: 3000,
          color: "warning",
          text: this.$t("OperationstartDate") + ', '+this.$t("OperationEndDate")+ this.$t("textNull"),
        });
        return;
      }

      this.$tools
        .ajax(pmapi.projects + "/" + this.project.id, "put", this.project, 1)
        .then((data) => {
          this.$router.go(-1);
        });
    },
    removeDocument(tr, index) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("title"),
        text: this.$t("deleteText"),
        acceptText: this.$t("yes"),
        cancelText: this.$t("cancleText"),
        accept: () => {
          if (this.oprationType == 'edit') {
            let id = this.$route.params.id;
            this.$tools
              .ajax(
                `${pmapi.projects}/${id}/remove/document/${tr.fileName}`,
                "put"
              )
              .then((data) => {
                this.project.files.splice(index, 1);
              });
          }else{
            this.project.files.splice(index, 1);
          }
        },
      });
    },
    addMember(val, name) {
      if (name == 'stakeholders') {
        let flag = true
        this.stakeholdersList.forEach((item)=>{
          if (val.stakeholdersName == item.name) {
            flag = false
          }
        })
        if (flag) {
          val.stakeholdersName !=='' && this.stakeholdersList.push({
            phoneNumber:val.stakeholdersMobile,
            name:val.stakeholdersName
          });
        } else {
           this.$vs.notify({
            title: '!!',
            text: this.$t('ProjectStakeholders') +this.$t('realname') + this.$t('repeat'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      } else {
        val&&this.projectMemberList.push(val);
        this.projectMemberList = [...new Set(this.projectMemberList)]
      }
     },
    addProjectStakeholders(projectList) {
      let error = this.errors.first(this.$t('ProjectStakeholders') + this.$t('mobile'))
      if(error){
        this.$vs.notify({
          position: "top-center",
          time: 3000,
          color: "warning",
          text: this.$t('ProjectStakeholders') + this.$t('mobile'),
        });
        return
      }
      this.addMember(projectList, 'stakeholders')
    },
    memberDel(index, id, name) {
      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('title'),
          text: this.$t('deleteText'),
          acceptText: this.$t('yes'),
          cancelText: this.$t('no'),
          accept: () => {
            if (name == 'stakeholders') {
						  this.stakeholdersList.splice(index,1)
            } else {
						  this.projectMemberList.splice(index,1)
            }
					}
			})
    },
    getConsumerList() {// 获取已添加客户列表
      let params = {
        page: 0,
        size: 10000,
      };
      this.$store.commit("UPDATE_LOADING", false);
      this.$tools
        .ajax(`${openapi.business}consumers`, "get", params)
        .then((data) => {
          let newContent = []
          data.content.forEach(rs => {
            newContent.push(rs.company)
          })
          this.consumerList = newContent
        });
    },
    getAddress(type, parentId) {
      let params = {
        parentId: parentId
      }
      this.$tools
        .ajax(openapi.address, "get", params)
        .then((data) => {
          switch(type) {
            case 'province': 
              this.placeInfo.province = data;
              break;
            case 'city':
              this.placeInfo.city = data;
              break;
            case 'area':
              this.placeInfo.area = data;
              break;
          }
        });
    },
    updateFile(file) {
      commonUpdateFile(cdnapi.cdn + 'getFileByName?name=' + file.fileName, file.alias);
    },
    updateProjectData(result) {
      this.$tools
        .ajax(
          `${pmapi.projects}/${result.typeId}/document`,
          "patch",
          result,
          1
        )
        .then(() => {
         
        });
    },
    inputValidate() {
      let errorList = this.errors.all()
      errorList.forEach((item) => {
        this.$vs.notify({
          position: "top-center",
          time: 3000,
          color: "warning",
          text: item,
        });
      })
      return errorList.length
    },
    getTypeList() {
      this.$store.commit("UPDATE_LOADING", false);
      this.$tools.ajax(`${pmapi.projectType}/getProjectTypes`, 'get').then((res) => {
        this.typeList = res
        this.project.type = res[0]
      })
    }
  },
  created() {
    this.getConsumerList();
    this.getAddress('province','');
  },
};
</script>
<style lang="scss" scoped>
.projectCol {
  width: 700px;
}
.w-400 { 
  width: 400px;
}
.w-300 {
  width: 300px;
}
.f-1 {
  flex:1
}
.labelwidth-100{
  width: 80px;
}
.projectCols {
  width: 400px;
  .projectMember{
    box-shadow: 0 0 5px #ccc6c6;
    border-radius: 3px;
    text-align: center;
    .listItem{
      padding: 0 10px;
      &:first-child{
        padding-top: 10px;
      }
      &:last-child{
        padding-bottom: 10px;
      }
      .feather-trash-2{
        height: 14px;
        width: 14px;
      }
    }
  }
}
.small-input {
  width: 200px;
}
.thumbnil {
  margin: 0 10px;
  // width: 130px;
  text-align: center;
  .thumbnil_detail {
    padding: 10px;
    max-width: 100%;
    border-radius: 5px;
    transition: 1s all;
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    background: rgba(124, 111, 111, 0.5);
    a {
      color: #fff;
    }
    .remove-file{
      position: absolute !important;
      top: 5px;
      right: 5px;
      background: rgba(0,0,0,.5);
      color: #fff;
      border-radius: 50%;
    }
  }
  &:hover .thumbnil_detail {
    opacity: 1;
  }
}
.project-name{
  padding-bottom: 10px;
  b{
    font-size: 16px;
  }
}
.info {
  .header {
    padding: 6px 0;
    font-weight: 600;
  }
  .bd{
    border: 1px solid #dad7d7;
    padding: 20px;
    .place{
      .vs-con-input-label{
        width: 500px;
      }
    }
    .noData{
      text-align: center;
    }
    .smalls{
      width: 200px !important;
    }
    .mark:after {
      content: "*";
      position: absolute;
      color: rgb(243, 9, 9);
    }
  }
  .w{
    width: 626px;
  }
}

</style>